function buildFeedbackAttributes(feedback) {
  return {
    rating: feedback.rating,
    description: feedback.description
  };
}

function buildFeedbackRelationships(professional_id) {
  return {
    professional: {
      data: {
        type: "professionals",
        id: professional_id
      }
    }
  };
}

function createRequestBody(payload) {
  return {
    data: {
      type: "feedbacks",
      attributes: buildFeedbackAttributes(payload),
      relationships: buildFeedbackRelationships(payload.professional_id)
    }
  };
}

export default {
  createRequestBody
};



// WEBPACK FOOTER //
// ./src/API/helpers/feedbacks.js